import { TitlePage } from "../../components/ui/TitlePage";
import { useApp } from "../../context/App";
import { Banner } from "../../components/sections/Banner";

export function LocationScreen() {

	const { mobile } = useApp()

	return (
		<div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start font-roboto">
			<TitlePage title={'Localização'} />

			<div className="flex flex-col lg:flex-row justify-between w-11/12 lg:w-3/5 mt-10 pb-16 lg:mt-16 lg:pb-24 gap-12 lg:gap-8">
				<div className="w-full lg:w-[55%] aspect-square lg:aspect-auto lg:h-[400px] rounded-2xl lg:rounded-xl overflow-hidden shadow-sm dark:shadow-premium-dark border border-gray-200 dark:border-border-dark">
					<iframe
						title="Mapa de localização da Prefeitura de Itajaí"
						className="w-full h-full border-none"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.972731874244!2d-48.67072753428655!3d-26.904360491625418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94d8cc65fb9adb4f%3A0x2ac8437a8cc5887c!2sPrefeitura%20Municipal%20de%20Itaja%C3%AD!5e0!3m2!1spt-BR!2sbr!4v1708628368508!5m2!1spt-BR!2sbr"
						loading="lazy"
					></iframe>
				</div>

				<div className="w-full lg:w-[40%] flex flex-col justify-center">
					<div className="font-roboto font-bold text-lg lg:text-base text-primary dark:text-primary-light mb-2">Endereço:</div>
					<div className="font-roboto font-light text-base lg:text-sm text-gray-700 dark:text-gray-300 mb-8 lg:mb-6 leading-relaxed">
						Rua Alberto Werner, 100<br />
						Bairro: Vila Operária<br />
						Itajaí (SC)<br />
						CEP: 88304-900
					</div>

					<div className="font-roboto font-bold text-lg lg:text-base text-primary dark:text-primary-light mb-2">Telefone:</div>
					<div className="font-roboto font-light text-base lg:text-sm text-gray-700 dark:text-gray-300 mb-8 lg:mb-6 leading-relaxed">(47) 3341-6000</div>

					<div className="font-roboto font-bold text-lg lg:text-base text-primary dark:text-primary-light mb-2">Atendimento:</div>
					<div className="font-roboto font-light text-base lg:text-sm text-gray-700 dark:text-gray-300 mb-8 lg:mb-6 leading-relaxed">
						08h às 12h e 14h às 18h de<br />
						segunda a sexta-feira
					</div>
				</div>
			</div>

			<Banner mobile={mobile} />
		</div>
	);
}